module.exports = __webpack_public_path__ + "media/preview/student-brands-d7011bfa.png";